<template>
  <div ref="box" style="height: calc(100%); overflow: auto">
    <Rwsptop :step="step" style="margin-bottom: 10px" @nextstep="nextstep" />
    <Rwstep1
      v-if="step == 1 || step == 5"
      v-loading="loading"
      :step="step"
      @nextstep="nextstep"
    />
    <Rwstep2
      v-if="step == 2 || step == 5"
      v-loading="loading"
      :step="step"
      @nextstep="nextstep"
    />
    <Rwstep3
      v-if="step == 3 || step == 5"
      v-loading="loading"
      :step="step"
      @nextstep="nextstep"
    />
    <Rwstep4
      v-if="step == 4 || step == 5"
      v-loading="loading"
      :step="step"
      @nextstep="nextstep"
    />
    <div v-if="step == 5" v-loading="loading" class="buttonList">
      <el-button v-preventReClick @click="nextstep(4)">上一步</el-button>
      <el-button
        v-preventReClick
        style="background-color: #4170ff; color: white"
        type="primary"
        @click="nextstep2()"
      >提交</el-button>
    </div>
    <Rwstep6 v-if="step == 6" :step="step" />
  </div>
</template>

<script>
// 获取接口地址
import { saveZcxxAll } from '@/assets/js/common.js'
import Rwsptop from '@/components/rwsptop'
import Rwstep1 from '@/components/editRwStep/rwstep1'
import Rwstep2 from '@/components/editRwStep/rwstep2'
import Rwstep3 from '@/components/editRwStep/rwstep3'
import Rwstep4 from '@/components/editRwStep/rwstep4'
import Rwstep6 from '@/components/editRwStep/rwstep6'
import { removeToken } from '@/utils/tool'

export default {
  name: 'RwsqStepAdmin',
  components: {
    // sideMenu,
    // Header,
    Rwsptop,
    Rwstep1,
    Rwstep2,
    Rwstep3,
    Rwstep4,
    Rwstep6
  },
  data() {
    return {
      loading: false,
      step: 1
    }
  },

  created() {
    window.addEventListener('beforeunload', (e) => this.test(e))
  },
  destroyed() {
    window.removeEventListener('beforeunload', (e) => this.test(e))
  },
  methods: {
    test(e) {
      // ...
      // alert('---')
      if (this.step == 6) {
        removeToken()
        this.$router.push('/login')
      }
    },
    // 步骤变换
    nextstep(step) {
      this.$refs.box.scrollTop = 0
      if (step == 0) {
        this.$router.push('/Rwsq')
      } else {
        this.step = step
      }
    },
    nextstep2() {
      this.loading = true
      saveZcxxAll(this.$store.state.RWLCType)
        .then((e) => {
          this.loading = false
          this.step = 6
        })
        .catch((e) => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.buttonList {
  padding: 80px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: white;
}
.buttonList button {
  width: 148px;
  height: 60px;
}
.buttonList button:nth-child(2) {
  margin-left: 190px;
}
</style>
